import { render, staticRenderFns } from "./ExpertAskForLeaveRecord.vue?vue&type=template&id=2e475744"
import script from "./ExpertAskForLeaveRecord.vue?vue&type=script&lang=js"
export * from "./ExpertAskForLeaveRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports